@use "variables" as *;

.box {
  padding: $spacing-2;
}
